export default __webpack_public_path__ + "static/media/LogoutAll.2739c406.svg";